module.exports = __webpack_public_path__ + "static/media/dna_alltraits_report.ed30a25a.png";